module.exports = __webpack_public_path__ + "static/media/emojione_flag-for-united-states.b44b7d4f.svg";